import type { OptionTypeBase } from 'react-select';
//FIX ME after updating to react-select v5 with proper typescript
// eslint-disable-next-line import/namespace
import type { NoticeProps } from 'react-select/src/components/Menu';

import { Box, type BoxProps } from '@frontend/legacy-components';

import { useSelectStyles } from '../SelectStylesContext';

export type NoOptionsMessageProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = NoticeProps<OptionType, IsMulti> & {
  innerProps: BoxProps;
};

export const NoOptionsMessage = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  innerProps,
  children,
}: NoOptionsMessageProps<OptionType, IsMulti>) => {
  const { noOptionsMessage: noOptionsMessageStyles } = useSelectStyles();

  return (
    <Box __css={noOptionsMessageStyles} {...innerProps}>
      {children}
    </Box>
  );
};
